module.exports = __webpack_public_path__ + "static/media/team12.6ec7929d.png";